import { getStatus } from '@/shared/config/missions'
import type { MissionWithProgress } from '@/types/mission'

import type { MissionShowStatus } from '../constants/showStatus'

export const getMissionShowStatus = (
  mission: MissionWithProgress | null | undefined
): MissionShowStatus => {
  if (!mission) return 'not_started'

  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  if (timeStatus?.slug === 'closed') return 'expired'
  if (timeStatus?.slug === 'soon') return 'not_started'

  const submissionStatus =
    mission._progress?.submission?.status ?? mission._progress?.status

  if (submissionStatus === 'approved' || mission._progress?.finished) {
    return 'approved'
  }

  if (submissionStatus === 'refused') return 'refused'
  if (submissionStatus === 'pending') return 'pending'

  return 'available'
}

export const canSubmitEvidence = (
  mission: MissionWithProgress | null | undefined,
  options: { isCapacityFull: boolean }
): boolean => {
  if (!mission) return false

  const showStatus = getMissionShowStatus(mission)
  if (showStatus === 'expired' || showStatus === 'not_started') return false
  if (options.isCapacityFull) return false
  if (showStatus === 'pending' || showStatus === 'approved') return false

  return showStatus === 'available' || showStatus === 'refused'
}

export const canResubmitEvidence = (
  mission: MissionWithProgress | null | undefined,
  options: { isCapacityFull: boolean }
): boolean => {
  if (!mission) return false

  const showStatus = getMissionShowStatus(mission)
  if (showStatus === 'expired' || showStatus === 'not_started') return false
  if (options.isCapacityFull) return false
  if (showStatus === 'approved') return false

  return showStatus === 'pending' || showStatus === 'refused'
}
